define('modules/editor/models/elements/text',['require','exports','module','./base','../../services/text_content/index'],function(require, exports, module) {
  var BaseElement = require("./base"),
      TextEditService = require("../../services/text_content/index");

  module.exports = BaseElement.extend({
    name: "element:text",
    defaultNameKey:"text",
    defaultPropertyGroups: [

    ],
    propertyGroups: [
      {
        name: "geometry",
        defaults: {
          height: "auto",
          width: 300,
          top: 0,
          left: 0
        }
      },
      {
        name: "idclass",
        defaults: {
          "id": "",
          "className": ""
        }
      },
      {
        name: "background",
        defaults: {
          color: "#ffffff",
          type: "solid",
          opacity: 0,
          imageUrl: "",
          secondColor: "#eeeeee",
          backgroundPosition: "left top",
          backgroundRepeat: "no-repeat",
          direction: "to left"
        }
      },
      {
        name: "border",
        defaults: {
          type: "none",
          width: 1,
          color: "#000000",
          position: "in",
          top: true,
          bottom: true,
          left: true,
          right: true,
          radius: 0
        }
      },
      {
        name: "text:content",
        defaults: { content: "Text Element" }
      }
    ],

    editText: function(){
      var currentText = this.getPropertyGroup("text:content").get("content");
      TextEditService.editText(currentText, _.bind(this.saveText, this));
    },
    saveText: function(content){
      this.getPropertyGroup("text:content").set("content", content);
    }
  });

});

